<template>
  <div class="c-handout" ref="handoutContainer">
    <p class="c-subtitle" v-if="videoUrls.length">视频</p>
    <y-player :video-url="url" v-for="url in videoUrls" :key="url" :width="'100%'" />
    <div v-if="handout">
      <p class="c-subtitle">讲义</p>
      <!-- <img :src="imgUrl" v-if="imgUrl" alt=""> -->
      <div class="c-container" v-katexHtml="handout"></div>
    </div>
    <div class="img-container" v-if="visibleImg">
      <div class="img-box">
        <i class="el-icon-close" @click="visibleImg=false"></i>
        <img :src="imgSrc" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import yPlayer from '@/components/y-player.vue';
import _ from 'lodash';

export default {
  components: { yPlayer },
  name: 'VideoHandout',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      imgSrc: '',
      visibleImg: false,
      exerciseType: this.$route.path.includes('exercise-type'),
    };
  },
  computed: {
    videoUrls() {
      if (this.exerciseType) {
        const firstVideo = _.get(this.data, 'tag_source[0].video_url');
        if (!firstVideo) {
          return [];
        }
        return this.data.tag_source.map((item) => item.video_url);
      }
      const evaVideo = _.get(this.data, 'resource[0].video_data.source_url');
      if (!evaVideo) {
        return [];
      }
      return this.data.resource.map((item) => item.video_data.source_url);
    },
    handout() {
      return _.get(this.data, 'handout');
    },
    imgUrl() {
      return _.get(this.data, 'resource[0].image_data.source_url');
    },
  },
  methods: {
    isIMG(e) {
      return e.target.tagName === 'IMG';
    },
    init() {
      if (this.$refs.handoutContainer) {
        this.$refs.handoutContainer.addEventListener('click', (e) => {
          if (this.isIMG(e)) {
            this.showImg(e);
          }
        });
      }
    },
    showImg(e) {
      this.imgSrc = e.target.src;
      this.visibleImg = true;
    },
    remove() {},
  },
  mounted() {
    this.init();
  },
  destroyed() {
    this.remove();
  },
};
</script>

<style lang="scss" scoped>
.c-handout {
  .c-subtitle {
    color: rgba(96, 98, 102, 1);
    font-size: 14px;
    margin: 12px 0;
  }
  .sq-player-wrap + .sq-player-wrap {
    margin-top: 20px;
  }
  img {
    max-width: 300px !important;
  }
  .c-container {
    background: rgba(247, 249, 249, 1);
    border-radius: 3px;
    color: rgba(96, 98, 102, 1);
    font-size: 14px;
    padding: 16px;
    box-sizing: border-box;
  }
  .img-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    z-index: 999;
    .img-box {
      width: 80%;
      height: 80%;
      background: #fff;
      box-shadow:0 0 10px rgba($color: #000000, $alpha: 0.6);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        max-height: 100%;
        max-width: 100% !important;
      }
    }
    .el-icon-close {
      position: absolute;
      right: 20px;
      top: 20px;
      font-size: 30px;
    }
  }
}
</style>
